module.exports = __webpack_public_path__ + "static/img/cows.bc8e675.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cows.jpg
// module id = 1506
// module chunks = 42